import React from 'react';
import { Box } from '@mui/material';

import optaLogo from '../../../images/pro/opta.svg';
import dsasLogo from '../../../images/pro/dsas.svg';

function Footer({
  isOpta = false,
  isDSAS = true,
  logoSize = 's',
  align = 'center',
}) {
  const logoHeightBySize = {
    xs: 12,
    s: 16,
    m: 20,
    l: 24,
  };

  const logoHeight = logoHeightBySize[logoSize] || logoHeightBySize.s;

  if (!isOpta && !isDSAS) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        minHeight: 50,
        mt: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: align,
        gap: 3,
        px: 2,
      }}
    >
      {isOpta ? (
        <Box
          component="img"
          src={optaLogo}
          alt="Opta"
          sx={{
            height: logoHeight,
            width: 'auto',
            display: 'block',
          }}
        />
      ) : null}

      {isDSAS ? (
        <Box
          component="img"
          src={dsasLogo}
          alt="DSAS"
          sx={{
            height: logoHeight*2.5, // Le logo DSAS est plus petit que le logo Opta, on peut donc lui appliquer un multiplicateur pour qu'il soit plus visible
            width: 'auto',
            display: 'block',
          }}
        />
      ) : null}
    </Box>
  );
}

export default Footer;